var mobileOpen = document.getElementById("mobileOpen");
var mobileClose = document.getElementById("mobileClose");
var page = document.body;
var menuTarget = document.getElementById("mobileMenu");
mobileOpen.addEventListener('click', function(event) {
	page.classList.toggle('mobileOverlay');
	menuTarget.classList.toggle('mobileShowing');
});
mobileClose.addEventListener('click', function(event) {
	page.classList.toggle('mobileOverlay');
	menuTarget.classList.toggle('mobileShowing');
});	
	

var pageGallery = GLightbox();



/*(function() { 

	var hoursContainer = document.getElementById("contactHours");
	var hoursGet = document.getElementById("jsHoursGet");
	var hoursShow = document.getElementById("jsHoursShow");
  
	function closeHours() {
		hoursContainer.classList.remove('open');
		//hoursShow.classList.remove('open');
	}

    hoursGet.addEventListener('click', function(e) {
		hoursContainer.classList.toggle('open');
		//hoursShow.classList.toggle('open');
    });
	
	window.addEventListener('click', function(e) {
		if (!e.target.matches('#contactHours')) {
		  // Moved the code here to its own function.
		  closeHours();
		}
	});	

})();*/ 

(function() {

	var hoursContainer = document.getElementById('contactHours');

	function closeHours() {
		hoursContainer.classList.remove('open');
	}

	hoursContainer.addEventListener('click', function(e) {
		this.classList.toggle('open');
		e.stopPropagation();
	});

	window.addEventListener('click', function(event) {
		if (event.target != hoursContainer) {
			closeHours();
		}
	});

})();



/*(function() {

	var jumpMenu = document.querySelector('#stickyJump');
		var height = jumpMenu.offsetHeight+"px";
		var start = jumpMenu.getBoundingClientRect().top;
	
	var body = document.querySelector('body');
	var begin = body.getBoundingClientRect().top;

	console.log("jumpMenu Start: " + start);	
	console.log("Jump Menu Height: " + height);		
	console.log("Body Start: " + begin);

	window.addEventListener("scroll", (event) => {
	
		var distance = jumpMenu.getBoundingClientRect().top;
	
		if ( distance > start ) {
			jumpMenu.classList.add('sticky');
		}
		
	});

	
	if ( begin < (start * -1) ) { 
		jumpMenu.classList.add('sticky');
	}

})();*/



// FRONT PAGE SLIDESHOW
const galleryGlide = new Glide('#jumboSlider',{
	type: 'carousel',
	perView: 1,
	perSwipe: '|',
	autoplay: 3000,
	hoverpause: true, 
	dragThreshold: 60
	
}).mount()


// RANDOM NUMBER 
/* function getRandomReview(min, max) {
	return Math.random() * (max - min) + min;
} */